import { useEffect, useState } from 'react';
import { AppShell, Burger, Group, Image } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { RouteConstants } from '../../constants';
import { BasicButton, LanguagePicker, Navigation } from 'components';
import { LOGO_IMG } from 'constants/app';
import classes from './index.module.css';

const { ROUTE_CREDIT_REQUEST, ROUTE_CREDIT_REQUEST_BASIC, ROUTE_CREDIT_REQUEST_EXISTS_SHORT, ROUTE_CREDIT_CARD_FORM } = RouteConstants;

const Layout = () => {
  const { t } = useTranslation();
  const [opened, { toggle, close }] = useDisclosure();
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    close();
  }, [location.pathname, close]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  function isFormPath() {
    return location.pathname.includes(ROUTE_CREDIT_REQUEST) || location.pathname.includes(ROUTE_CREDIT_CARD_FORM);
  }

  return (
    <AppShell
      navbar={{
        width: 300,
        breakpoint: 'lg',
        collapsed: { desktop: true, mobile: !opened },
      }}
    >
      <AppShell.Header className={`${classes.header} ${scrolled ? classes.scrolled : ''} ${isFormPath() ? classes.request : ''}`}>
        <Group className={classes.inner}>
          <Burger
            opened={opened}
            color={'white'}
            hiddenFrom={'lg'}
            size={'sm'}
            onClick={toggle}
            className={classes.burger}
          />
          <Group justify={'space-between'} style={{ flex: 1 }}>
            <Image
              src={LOGO_IMG}
              alt={'Webkredit.ch logo'}
              className={classes.logo}
            />
            <Group gap={0} visibleFrom={'lg'}>
              <Navigation />
            </Group>
            <Group className={classes.controls}>
              <LanguagePicker />
              <BasicButton
                header={true}
                disabled={location.pathname.includes(ROUTE_CREDIT_REQUEST) && !location.pathname.includes(ROUTE_CREDIT_REQUEST_EXISTS_SHORT)}
                onClick={() => navigate(ROUTE_CREDIT_REQUEST_BASIC)}
              >
                {t('action.startRequest')}
              </BasicButton>
            </Group>
          </Group>
        </Group>
      </AppShell.Header>
      <AppShell.Navbar
        py={'md'}
        px={4}
        hiddenFrom={'lg'}
        className={classes.navbar}
        zIndex={299}
      >
        <Navigation onNavigate={toggle} />
      </AppShell.Navbar>
      <Outlet />
    </AppShell>
  );
}

export default Layout;